import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import { inject } from '@vercel/analytics';
inject();


Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
